import Select from 'react-select';
import ActiveArchiveToggle from '../Filters/ActiveArchiveToggle';
import AdminSearchBox from '../Admin/reusableComponents/AdminSearchBox';
import PromptTemplateForm from './PromptTemplateForm';

export const SearchTypeSelect = ({ value, onChange }) => (
    <Select
        value={value}
        onChange={onChange}
        options={[
            {
                label: <div>Library</div>,
                value: 'library',
            },
            {
                label: <div>Team</div>,
                value: 'team',
            },
        ]}
        placeholder="Filter type"
        isClearable
    />
);
const PromptTemplateFilters = ({
    onSearch = () => {},
    inputRef,
    isActive,
    setIsActive = () => {},
    searchType,
    onSearchTypeChange = () => {},
    fetchOnAction,
    loading,
}) => {
    return (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
                <AdminSearchBox search={undefined} onSearch={onSearch} placeholder={'Search...'} inputRef={inputRef} />
                <div className="ml-4">
                    <SearchTypeSelect value={searchType} onChange={onSearchTypeChange} />
                </div>
            </div>
            <div className="d-flex gap-2">
                <div className="mr-4">
                    <ActiveArchiveToggle isActive={isActive} setIsActive={setIsActive} disabled={loading} />
                </div>
                <PromptTemplateForm onCreate={() => fetchOnAction(1)} />
            </div>
        </div>
    );
};
export default PromptTemplateFilters;
